import {
  useState,
  useEffect,
  useContext,
  PropsWithChildren,
  createContext,
  FC,
} from 'react';

const NetworkConnectionStatusContext = createContext(true);

export const NetworkConnectionStatusProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [connectionstatus, setConnectionStatus] = useState<boolean>(true);

  useEffect(() => {
    window.addEventListener('offline', () => {
      setConnectionStatus(false);
    });
    window.addEventListener('online', () => {
      setConnectionStatus(true);
    });

    return () => {
      window.removeEventListener('offline', () => {
        setConnectionStatus(false);
      });
      window.removeEventListener('online', () => {
        setConnectionStatus(true);
      });
    };
  }, []);

  return (
    <NetworkConnectionStatusContext.Provider value={connectionstatus}>
      {children}
    </NetworkConnectionStatusContext.Provider>
  );
};

export const useNetworkConnectionStatus = () => {
  const store = useContext(NetworkConnectionStatusContext);
  return store;
};
